export default class Column {
  id;
  name;
  searchWeight;

  constructor(columnWire) {
    this.id = columnWire.column_dto_id;
    this.name = columnWire.column_dto_name;
    this.searchWeight = columnWire.column_dto_search_weight;
  }
}
